export default __webpack_public_path__ + "static/media/NoPhoto.f75feca8.svg";